import React from 'react';
import DynamicForm from '../../../forms/components/DynamicForm';

const TaskCancellationForm = ({ task, onClose, onSuccess }) => {
  const handleSuccess = async (formResponseData) => {


    // DynamicForm ya manejó todo:
    // 1. Subió las imágenes
    // 2. Guardó la respuesta del formulario custom (si existe)
    // 3. Canceló la tarea con los campos genéricos

    // Solo cerramos el modal y notificamos al padre
    onClose();
    onSuccess();
  };

  return (
    <DynamicForm
      task={task}
      formType="cancelacion"
      onClose={onClose}
      onSuccess={handleSuccess}
      title={`Cancelar Tarea - ${task.client?.name || task.client?.email || 'Cliente'}`}
      submitButtonText="Confirmar Cancelación"
    />
  );
};

export default TaskCancellationForm;

